module.exports = __webpack_public_path__ + "personalcollege_cases.jpg?efb0c0c1d2aba9d2883acb0e1ac3d954";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cases/personalcollege_cases.jpg
// module id = 91
// module chunks = 0